module.exports = __webpack_public_path__ + "content/4335d5f923e59343903e1b055ef4570c.svg";